var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlankSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16mm",
    height: "16.009mm",
    viewBox: "0 0 16 16.009",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.449 -39.33)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2645
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.449,
    y: 39.33,
    width: 16,
    height: 15.991,
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.449,
    y: 39.33,
    width: 2,
    height: 15.991,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.449,
    y: 39.339,
    width: 2,
    height: 15.991,
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.449 39.33v1.9987h14l1.9999-1.9889v-0.0098z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.449 53.322-1.9999 1.9987h16v-1.9987z",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2645
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.456 55.318 0.0096-1.9511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.462 53.3-0.0032 2.0181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.449 55.321 2.0001-1.9988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.449 53.322 1.16e-4 1.9987"
  })), /*#__PURE__*/React.createElement("path", {
    className: "UnoptimicedTransforms",
    d: "m0 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "UnoptimicedTransforms",
    d: "m0 0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankSquare);
export default __webpack_public_path__ + "static/media/BlankSquare.ab75f1431c599c7c17f6efbbfe1deffe.svg";
export { ForwardRef as ReactComponent };